import Etapas from "../Components/Producao/Etapas/Etapas";
import Classificacao from "../Components/Producao/Classificacao/Classificacao";

export default function Producao() {
  return (
    <div>
      <Classificacao />
      <Etapas />
    </div>
  );
}
